import React from 'react';
import { createRoot } from 'react-dom/client';
import ProducerDirectoryWithFilters from '../../src/js/producerDirectory/ProducerDirectoryWithFilters';
import '../../src/styles/artists-directory.less';
import { authController } from '@reedexpo/authorization-component-ui';

if (global.window && global.window.document) {
  const { props, elementId } = window.reactSettingsArtistsDirectory;
  const authSettings = window.authSettings;
  if (authSettings && authSettings.usePkce) {
    authController.initialize(authSettings);
  }
  const testVariantsProps = window.testVariants;
  
  const container = document.getElementById(elementId);
  const root = createRoot(container);
  root.render(<ProducerDirectoryWithFilters {...props} testVariants={testVariantsProps} />);
}

